import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { setSelectedBaseMap } from "../../../gis/src/redux/gisSlice";

interface MapToggleProps {
}

const GISDropdown: React.FC<MapToggleProps> = () => {
  const dispatch = useDispatch();

  const selectedBaseMap = useSelector((state: any) => state.gisData?.selectedBaseMap || "");

  const options = [
    { value: "osm", label: "Open Street Map" },
    { value: "satellite", label: "Satellite" },
    { value: "terrain", label: "Terrain" },
    { value: "roadmap", label: "Roadmap" },
    { value: "hybrid", label: "Hybrid" },
    // { value: "bhuvanBase", label: "Bhuvan Base Map" },
    // { value: "bhuvanImagery", label: "Bhuvan Satellite Imagery" },
  ];

  return (
    <div id="gisdropdown" className="gis-dropdown flex items-center justify-end rounded-lg bg-gray-000 px-3 py-0.5 hover:shadow-lg transition-shadow duration-200">
      <select
        className="h-full rounded-lg border-none"
        value={selectedBaseMap}
        onChange={(e) => { 
          dispatch(setSelectedBaseMap(e.target.value))}}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default GISDropdown;